import { render, staticRenderFns } from "./login-ip-whitelist-dialog.vue?vue&type=template&id=38cb8d96&scoped=true"
import script from "./login-ip-whitelist-dialog.vue?vue&type=script&lang=js"
export * from "./login-ip-whitelist-dialog.vue?vue&type=script&lang=js"
import style0 from "./login-ip-whitelist-dialog.vue?vue&type=style&index=0&id=38cb8d96&prod&scoped=true&lang=scss"
import style1 from "./login-ip-whitelist-dialog.vue?vue&type=style&index=1&id=38cb8d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb8d96",
  null
  
)

export default component.exports